module.exports = __webpack_public_path__ + "static-portal/img/map-m2.523ff7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map-m2.png
// module id = nqex
// module chunks = 4